import React from 'react';
import { Modal } from 'react-bootstrap';

const ImageZoomModal = ({ show, onHide, src, alt }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      <Modal.Body style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#222',
        padding: 0
      }}>
        <img
          src={src}
          alt={alt}
          style={{
            maxWidth: '100%',
            maxHeight: '80vh',
            objectFit: 'contain',
            cursor: 'zoom-out',
            borderRadius: 8,
            boxShadow: '0 2px 16px rgba(0,0,0,0.4)'
          }}
          onClick={onHide}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ImageZoomModal;
